export default __webpack_public_path__ + "static/SRF 3240ACS50 - Fiche de spécifications et données techniques -56348806b3504441ce82745cfcf2ae6c.pdf";